import React from 'react';

export const TableSkeleton = ({ rows = 5, columns = 6 }) => {
    return (
        <div className="w-full space-y-3 p-4 bg-white rounded-2xl border border-gray-100">
            {Array.from({ length: rows }).map((_, rIdx) => (
                <div key={rIdx} className="flex items-center justify-between gap-4 py-3 border-b border-gray-50 last:border-0 animate-pulse">
                    <div className="flex items-center gap-3 flex-1">
                        <div className="w-10 h-10 rounded-xl bg-gray-200 shrink-0"></div>
                        <div className="space-y-1.5 flex-1">
                            <div className="h-3.5 bg-gray-200 rounded-md w-48"></div>
                            <div className="h-2.5 bg-gray-100 rounded-md w-24"></div>
                        </div>
                    </div>
                    <div className="h-4 bg-gray-100 rounded-md w-16 hidden sm:block"></div>
                    <div className="h-4 bg-gray-200 rounded-md w-20"></div>
                    <div className="h-5 bg-gray-100 rounded-full w-14 hidden md:block"></div>
                    <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-gray-200"></div>
                        <div className="w-7 h-7 rounded-lg bg-gray-100"></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export const PageLoader = ({ label = "Loading data..." }) => {
    return (
        <div className="flex flex-col items-center justify-center py-20 space-y-3">
            <div className="relative w-12 h-12">
                <div className="absolute inset-0 rounded-full border-4 border-indigo-100"></div>
                <div className="absolute inset-0 rounded-full border-4 border-indigo-600 border-t-transparent animate-spin"></div>
            </div>
            <span className="text-xs font-semibold text-gray-500 tracking-wide">{label}</span>
        </div>
    );
};

export default TableSkeleton;
